import { configureStore } from '@reduxjs/toolkit'
import clientesEditarSlice from 'routes/clientes/Editar/clientesEditarSlice'
import filialesCoberturaSlice from 'routes/filialesEditar/components/CoberturaTab/filialesCoberturaSlice'
import filialesContactosSlice from 'routes/filialesEditar/components/ContactosTab/filialesContactosSlice'
import filialesDistanciasSlice from 'routes/filialesEditar/components/DistanciasTab/filialesDistanciasSlice'
import filialesDomiciliosSlice from 'routes/filialesEditar/components/DomiciliosTab/filialesDomiciliosSlice'
import filialesZonasSlice from 'routes/filialesEditar/components/ZonasTab/filialesZonasSlice'
import filialesEditarSlice from 'routes/filialesEditar/filialesEditarSlice'
import usuariosEditarSlice from 'routes/usuarios/components/Editar/usuariosEditarSlice'
import generalSlice from './generalSlice'

export const store = configureStore({
  reducer: {
    general: generalSlice,

    usuariosEditar: usuariosEditarSlice,

    clientesEditar: clientesEditarSlice,

    filialesEditar: filialesEditarSlice,
    filialesCobertura: filialesCoberturaSlice,
    filialesZonas: filialesZonasSlice,
    filialesDomicilios: filialesDomiciliosSlice,
    filialesContactos: filialesContactosSlice,
    filialesDistancias: filialesDistanciasSlice,
  },
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["filialesCoberturas/setZonaCrear", "filialesCoberturas/setZonas", "filialesZonas/setZonaCrear", "filialesZonas/setZonas",],
        ignoredPaths: ["filialesCobertura.zonaCrear", "filialesCobertura.zonas", "filialesZonas.zonaCrear", "filialesZonas.zonas",]
      }
    })
  }
})